<svg-icon
  class="affiliates-tier-card--icon"
  [src]="`assets/icons/affiliates/tiers/tier-${tier().fe_tier}-blur.svg`"
/>
<p class="affiliates-tier-card--tier-name">tier {{ tier().fe_tier }}</p>
<div class="affiliates-tier-card--wagered">
  <app-cost
    [color]="isActive() ? tierColor() : 'var(--yellow)'"
    [gap]="4"
    [cost]="tier().requirement"
  ></app-cost>
  Wagered
</div>
<div class="affiliates-tier-card--rewards">
  <p class="affiliates-tier-card--rewards__title">Rewards</p>
  <ul class="affiliates-tier-card--rewards__list">
    <li class="affiliates-tier-card--rewards__item">
      Rake commission: {{ tier().rake_perc }}%
    </li>
    <li class="affiliates-tier-card--rewards__item">
      Wager commission: {{ tier().wager_perc }}%
    </li>
    <li class="affiliates-tier-card--rewards__item">
      Deposit commission: {{ tier().deposit_perc }}%
    </li>
  </ul>
</div>
<div class="affiliates-tier-card--requirements">
  <p class="affiliates-tier-card--requirements__title">Requirements</p>
  <ul class="affiliates-tier-card--requirements__list">
    <li class="affiliates-tier-card--requirements__item">
      Deposits: {{ tier().requirement }}
    </li>
  </ul>
</div>
